export { default as OTXAdapterDocumentation } from './OTXAdapterDocumentation';
export { default as OTXAdapterFieldSet } from './OTXAdapterFieldSet';
export { default as OTXAdapterSummary } from './OTXAdapterSummary';



// WEBPACK FOOTER //
// ./src/web/components/adapters/otx/index.jsx